import React, { useEffect, useState } from 'react'
import { Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import { IdCategoriesState, typeCategoriesFilters } from 'model/dashboardCategories/dCategoriesReducer'
import {
    dCategoriesBulkDeleteSagaAC,
    dCategoriesClearFiltersAC,
    dCategoriesDeleteItemSagaAC, dCategoriesRecoverBulkSagaAC,
    dCategoriesSetDataSagaAC,
    dCategoriesSetDetailItemAC, dCategoriesSetFiltersAC, dCategoriesSetItemsForPageAC, dCategoriesSetPageNumberAC
} from 'model/dashboardCategories/dCategoriesActionCreators'
import { ViewDataCategories } from './ViewComponent';
import { typePaginationDashboardObject } from '../DashboardContentTable/PaginationDashboard/PaginationDashboard';
import { useInputChange } from 'hooks/useInputChange';
import { typeRequestPagination } from 'model/system/constants';


// Type
export type typeDataCategories = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>

}
export type typeDataCategoriesRowActions = { title: JSX.Element, action: (id: string) => void }[]
export type typeDataCategoriesBulkActions = { title: JSX.Element, action: () => void }[]


// Component
export const DataCategories: React.FC<typeDataCategories> = ({
                                                                 variant,
                                                                 setSidebarOpen,

                                                             }) => {

    const dispatch = useDispatch()

    // DateFilter
    const [ isActiveFilters, setIsActiveFilters ] = useState(false)
    const filters = useSelector((state: { dCategories: IdCategoriesState }) => state.dCategories.filters)
    const [ openFilterBar, setOpenFilterBar ] = useState(false)

    /// Pagination
    const pagination: typePaginationDashboardObject = {
        paginationObject: useSelector((state: { dCategories: IdCategoriesState }) => state.dCategories.pagination),
        onGoToPage: (id) => dispatch(dCategoriesSetPageNumberAC(id)),
        onSelectItems: (itemsPerPage) => dispatch(dCategoriesSetItemsForPageAC(itemsPerPage))

    }
    const makePaginationRequest = (pagination: typePaginationDashboardObject): typeRequestPagination => {
        return {
            page: pagination.paginationObject.pageNumber,
            size: pagination.paginationObject.itemsPerPage!
        }
    }

    // Did mount & Did unmount
    useEffect(() => {

        return () => {
            dispatch(dCategoriesClearFiltersAC())
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        dispatch(dCategoriesSetDataSagaAC(
            filters,
            { page: pagination.paginationObject.pageNumber, size: pagination.paginationObject.itemsPerPage! }
        ))
// eslint-disable-next-line
    }, [ filters, pagination.paginationObject.pageNumber, pagination.paginationObject.itemsPerPage ])

    // Search panel

    const searchName = useSelector((state: { dCategories: IdCategoriesState }) => state.dCategories.filters?.name)

    const {
        value: searchValue,
        setValue: setSearchValue,
        changeValueHandler: onChangeSearchValue
    } = useInputChange(searchName || '')

    const onClearSearch = () => {
        dispatch(dCategoriesSetFiltersAC({
                                             name: null
                                         }))

        setSearchValue('')
    }
    const onEnterSearch = () => {

        const filters: typeCategoriesFilters = {
            name: searchValue.trim()
        }
        dispatch(dCategoriesSetFiltersAC(filters))

    }

    // Popup add
    const [ openPopupAdd, setOpenPopupAdd ] = useState(false)

    // Popup edit
    const [ openPopupEdit, setOpenPopupEdit ] = useState(false)

    // Delete dialog
    const [ openDeleteDialog, setOpenDeleteDialog ] = useState(false)


    const currentItem = useSelector((state: { dCategories: IdCategoriesState }) => state.dCategories.detailItem)


    //  selected

    const categoriesList = useSelector((state: { dCategories: IdCategoriesState }) =>
                                           state.dCategories.data)


    // Recover dialog
    const [ openRecoverDialog, setOpenRecoverDialog ] = useState(false)

    const onRecoverConfirmHandler = () => {
        dispatch(dCategoriesRecoverBulkSagaAC([ currentItem!.id ], filters, makePaginationRequest(pagination)))
        setOpenRecoverDialog(false)
    }
    const onRecoverCancelHandler = () => {
        setOpenRecoverDialog(false)
    }


// Bulk delete dialog
    const [ openBulkDeleteDialog, setBulkOpenDeleteDialog ] = useState(false)

    const onBulkDeleteConfirmHandler = () => {
        const bulkIds: string[] = categoriesList
            .filter(item => item.checked)
            .map(item => item.id)

        dispatch(dCategoriesBulkDeleteSagaAC(bulkIds, filters, makePaginationRequest(pagination)))
        setBulkOpenDeleteDialog(false)
    }
    const onBulkDeleteCancelHandler = () => {
        setBulkOpenDeleteDialog(false)
    }

    // Delete dialog actions
    const onDeleteCancelHandler = () => {
        setOpenDeleteDialog(false)
    }
    const onDeleteConfirmHandler = () => {
        dispatch(dCategoriesDeleteItemSagaAC(currentItem!.id, filters, makePaginationRequest(pagination)))
        setOpenDeleteDialog(false)
    }

    // Bulk recover dialog
    const [ openBulkRecoverDialog, setBulkOpenRecoverDialog ] = useState(false)

    const onBulkRecoverConfirmHandler = () => {
        const bulkIds: string[] = categoriesList
            .filter(item => item.checked)
            .map(item => item.id)

        dispatch(dCategoriesRecoverBulkSagaAC(bulkIds, filters, makePaginationRequest(pagination)))
        setBulkOpenRecoverDialog(false)
    }

    const onBulkRecoverCancelHandler = () => {
        setBulkOpenRecoverDialog(false)
    }


    // Item actions
    const rowsActions = [
        {
            title: <Trans>Edit</Trans>,
            action: (id: string) => {
                dispatch(dCategoriesSetDetailItemAC(id))
                setOpenPopupEdit(true)
            }
        },
        {
            id: 'recover',
            title: <Trans>Recover</Trans>,
            action: (id: string) => {
                dispatch(dCategoriesSetDetailItemAC(id))
                setOpenRecoverDialog(true)
            }
        },
        {
            id: 'delete',
            title: <Trans>Delete</Trans>,
            action: (id: string) => {
                dispatch(dCategoriesSetDetailItemAC(id))
                setOpenDeleteDialog(true)
            }
        },
    ]


    // Make bulk actions

    const bulkActions: typeDataCategoriesBulkActions = filters ?
        filters.deleted ? [
                {
                    title: <Trans>Recover</Trans>,
                    action: () => setBulkOpenRecoverDialog(true)
                } ] :
            [ {
                title: <Trans>Delete</Trans>,
                action: () => setBulkOpenDeleteDialog(true)
            } ]

        : [ {
            title: <Trans>Delete</Trans>,
            action: () => setBulkOpenDeleteDialog(true)
        } ]

    return (
        <ViewDataCategories
            variant={ variant }
            setSidebarOpen={ setSidebarOpen }

            openFilterBar={ openFilterBar }
            setOpenFilterBar={ setOpenFilterBar }

            openPopupAdd={ openPopupAdd }
            setOpenPopupAdd={ setOpenPopupAdd }

            openPopupEdit={ openPopupEdit }
            setOpenPopupEdit={ setOpenPopupEdit }

            openDeleteDialog={ openDeleteDialog }
            setOpenDeleteDialog={ setOpenDeleteDialog }
            onDeleteConfirmHandler={ onDeleteConfirmHandler }
            onDeleteCancelHandler={ onDeleteCancelHandler }

            openBulkDeleteDialog={ openBulkDeleteDialog }
            setBulkOpenDeleteDialog={ setBulkOpenDeleteDialog }
            onBulkDeleteConfirmHandler={ onBulkDeleteConfirmHandler }
            onBulkDeleteCancelHandler={ onBulkDeleteCancelHandler }
            deleteCount={ categoriesList.filter(item => item.checked).length }

            onBulkRecoverCancelHandler={ onBulkRecoverCancelHandler }
            onBulkRecoverConfirmHandler={ onBulkRecoverConfirmHandler }
            openBulkRecoverDialog={ openBulkRecoverDialog }
            setBulkOpenRecoverDialog={ setBulkOpenRecoverDialog }
            recoverCount={ categoriesList.filter(item => item.checked).length }

            openRecoverDialog={ openRecoverDialog }
            setOpenRecoverDialog={ setOpenRecoverDialog }
            onRecoverConfirmHandler={ onRecoverConfirmHandler }
            onRecoverCancelHandler={ onRecoverCancelHandler }

            searchValue={ searchValue }
            onChangeSearchValue={ onChangeSearchValue }
            onClearSearch={ onClearSearch }
            onEnterSearch={ onEnterSearch }
            rowsActions={ rowsActions }
            bulkActions={ bulkActions }


            currentItem={ currentItem }

            pagination={ pagination }
            isActiveFilters={ isActiveFilters }
            setIsActiveFilters={ setIsActiveFilters }
        />

    )
}
